import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

export type CompanyMachineDto = ClientInferResponseBody<
  typeof contract.companyMachines.findAll,
  200
>[number];

export const fetchCompanyMachines = async (): Promise<CompanyMachineDto[] | null> => {
  const response = await api.companyMachines.findAll.query();

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
